import React, { useState, useEffect, useRef } from 'react';
import Container from '@/components/UI/mobile/Container';
import MainButton from '@/components/UI/mobile/MainButton';
import { Box, Typography, IconButton } from '@mui/material';
import { GrRefresh } from 'react-icons/gr';
import color from '@/styles/mobile/color';
import moment from 'moment';
import { createCanvas } from 'canvas';
import JsBarcode from 'jsbarcode';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from '@/redux/slices/userSlice';
import axios from 'axios';
import styled from '@emotion/styled';
import BarcodeItem from './components/BarcodeItem';
import BillDetail from './components/BillDetail';
import { MainText, SecondaryText } from '../../components/UI/mobile/ui';
import BillItem from './components/BillItem';
import client from '../../lib/feathers';

const uiColor = color.ui;

const Spin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  animation: ${(props) =>
    props.isLoading ? 'spin 1s linear infinite' : 'none'};
  width: 5vw;
  height: 5vw;
  @media (orientation: landscape) {
    width: 3vw;
    height: 3vw;
  }
`;
const Divider = styled.div`
  width: 100%;
  height: 0.2vw;
  margin: 2.3vw 0;
  background-color: ${uiColor.divider};
  @media (orientation: landscape) {
    margin: 0.45vw 0;
  }
`;
const DetailContainer = styled.div`
  margin-top: 28.4vw;
  @media (orientation: landscape) {
    margin-top: 5vw;
  }
`;
const PayFrontDesk = () => {
  const [bills, setBills] = useState([]);
  const [thisMonthBill, setThisMonthBill] = useState(null);
  const [currentBill, setCurrentBill] = useState(null);
  const [currentPage, setCurrentPage] = useState('billList');
  const [isLandscape, setIsLandscape] = useState(screen.width > screen.height);
  const [currentBarcode, setCurrentBarcode] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [trigger, setTrigger] = useState({});
  const [lastUpdate, setLastUpdate] = useState(moment());
  const [communityData, setCommunityData] = useState({});
  const [html, setHtml] = useState({});
  const btnRef = useRef();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  useEffect(() => {
    (async () => {
      const res = await client.service('communityData').find({});
      setCommunityData(res.data[0]);
    })();
  }, []);

  useEffect(() => {
    client.service('chatMessages').on('taiwanPayTradeInfo', (a) => {
      setHtml(JSON.parse(a).twPayData);
    });
    if (html?.actionUrl) {
      btnRef.current.click();
    }
  }, [html]);
  // 取得使用者帳單資料
  useEffect(() => {
    setIsLoading(true);
    let id = null;
    // 獲取帳單的function
    const getBills = async () => {
      try {
        const billsData = (
          await axios.post(
            '/ezcon/api/financeList',
            { householdNumber: user.auth.user.householdNumbers[0] },
            {
              headers: {
                authorization: localStorage.getItem('feathers-jwt'),
              },
            }
          )
        ).data.payList;
        console.log(billsData);
        setBills(
          billsData.sort((a, b) => {
            return a.billTime < b.billTime ? 1 : -1;
          })
        );
        setLastUpdate(moment());
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    // 如果有使用者資料，則獲取帳單，如果沒有就撈使用者資料
    if (user.auth.user._id) {
      clearTimeout(id);
      id = setTimeout(() => getBills(), 1000);
    } else {
      dispatch(fetchUser());
    }
  }, [dispatch, user, trigger]);

  // 取得本月帳單資料
  useEffect(() => {
    if (bills.length > 0) {
      setThisMonthBill(
        bills.find(
          (bill) => moment(bill.billTime).month() === moment().month()
        ) || null
      );
    }
  }, [bills]);

  // 將本月帳單預設為當前顯示帳單
  useEffect(() => {
    if (thisMonthBill) {
      setCurrentBill(thisMonthBill);
    }
  }, [thisMonthBill]);

  // 使用當前帳單建立條碼資料
  useEffect(() => {
    if (currentBill?.money < 20000) {
      const barcode = {
        1: currentBill.barcode1,
        2: currentBill.barcode2,
        3: currentBill.barcode3,
      };
      if (!Object.values(barcode).includes(undefined)) {
        Object.entries(barcode).forEach(([key, value]) => {
          const canvas = createCanvas();
          JsBarcode(canvas, value, {
            background: '#e3e6e8',
            displayValue: false,
            format: 'CODE39',
          });
          setCurrentBarcode((prevState) => ({
            ...prevState,
            [key]: {
              name: `條碼${key}`,
              imgUrl: canvas.toDataURL(),
              letter: value,
            },
          }));
        });
      }
    }
  }, [currentBill, setCurrentBarcode]);

  // 偵測裝置是否橫向
  useEffect(() => {
    window.addEventListener('orientationchange', () => {
      setIsLandscape(screen.width > screen.height);
    });
  }, []);

  const handleReturnBillList = () => {
    setCurrentPage('billList');
    setCurrentBill(thisMonthBill);
  };

  console.log(currentBill);

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {currentBill && (
        <>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <MainText>{currentBill.itemName}</MainText>
            <Box
              sx={{
                fontWeight: '600',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'baseLine',
                color: uiColor.textAlert,
              }}
            >
              <Typography
                sx={{
                  fontSize: '3.6vw',
                  lineHeight: '5.6vw',
                  '@media (orientation: landscape)': {
                    fontSize: '1.8vw',
                    lineHeight: '3vw',
                  },
                }}
              >
                $
              </Typography>
              <Typography
                sx={{
                  fontSize: '5.6vw',
                  lineHeight: '5.6vw',
                  '@media (orientation: landscape)': {
                    fontSize: '2.8vw',
                    lineHeight: '3vw',
                  },
                }}
              >
                {currentBill.money.toLocaleString()}
              </Typography>
              <Typography
                sx={{
                  fontSize: '3.6vw',
                  lineHeight: '5.6vw',
                  '@media (orientation: landscape)': {
                    fontSize: '1.8vw',
                    lineHeight: '3vw',
                  },
                }}
              >
                元
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            {currentBill.status !== 3 && (
              <SecondaryText
                color={uiColor.textAlert}
                sx={{
                  marginTop: '1.3vw',
                  '@media (orientation: landscape)': {
                    marginTop: '0.45vw',
                  },
                }}
              >
                {`繳費期限${moment(currentBill.expireDate).format(
                  'YYYY-MM-DD'
                )}`}
              </SecondaryText>
            )}
            <Box
              sx={{
                fontWeight: '600',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'baseLine',
                color: uiColor.textAlert,
              }}
            >
              {currentPage === 'barcode' && (
                <SecondaryText
                  color={uiColor.textAlert}
                  sx={{
                    marginTop: '1.3vw',
                    '@media (orientation: landscape)': {
                      marginTop: '0.45vw',
                    },
                  }}
                >
                  {`手續費：$${communityData.payFee}元`}
                </SecondaryText>
              )}
            </Box>
          </Box>
          {currentPage === 'detail' && (
            <DetailContainer>
              <MainText>繳費明細</MainText>
              <Divider />
            </DetailContainer>
          )}
          {currentPage === 'billList' && (
            <>
              <MainButton
                sx={{
                  marginTop: '2.8vw',
                  alignSelf: 'center',
                }}
                disableRipple
                onClick={() => {
                  if (currentBill.money < 20000) {
                    setCurrentPage('barcode');
                  } else {
                    setCurrentPage('payInformation');
                  }
                }}
              >
                超商繳費資訊
              </MainButton>
              {/* <MainButton
                sx={{
                  marginTop: '2.8vw',
                  alignSelf: 'center',
                }}
                disableRipple
                onClick={() => {
                  console.log('hi');
                  client
                    .service('chatMessages')
                    .emit('taiwanPayTradeInfo', { payId: currentBill._id });
                }}
              >
                信用卡付款
              </MainButton> */}
            </>
          )}
        </>
      )}
      {!currentBill && (
        <Box
          sx={{
            marginTop: '21.4vw',
            padding: '0.7vw',
            borderRadius: '0.8vw',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            border: `0.2vw solid ${uiColor.divider}`,
            '@media (orientation: landscape)': {
              width: 'fit-content',
              borderWidth: '0.1vw',
              marginTop: '2.5vw',
              padding: '0.35vw',
              borderRadius: '0.4vw',
              alignSelf: 'center',
            },
          }}
        >
          <MainText>無本月份帳單</MainText>
        </Box>
      )}
      {currentPage === 'billList' && (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              borderBottom: `0.2vw solid ${uiColor.divider}`,
              alignItems: 'center',
              margin: '8.8vw 0 2.8vw 0',
              '@media (orientation: landscape)': {
                margin: '4vw 0 0 0',
                borderBottom: `0.1vw solid ${uiColor.divider}`,
              },
            }}
          >
            <Box>
              <MainText>帳單列表</MainText>
              <SecondaryText
                sx={{
                  marginTop: '0.7vw',
                  '@media (orientation: landscape)': {
                    margin: '0',
                  },
                }}
              >
                {`最後更新${lastUpdate.format('YYYY-MM-DD HH:mm:ss')}`}
              </SecondaryText>
            </Box>
            <IconButton onClick={() => setTrigger({})}>
              <Spin {...{ isLoading }}>
                <GrRefresh size={isLandscape ? '3vw' : '5vw'} />
              </Spin>
            </IconButton>
          </Box>
          <Box
            sx={{
              flexGrow: '1',
              overflowY: 'auto',
            }}
          >
            {bills.length > 0 &&
              bills.map((bill) => (
                <BillItem
                  key={bill._id}
                  {...{
                    bill,
                    setCurrentBill,
                    setCurrentPage,
                  }}
                />
              ))}
          </Box>
        </>
      )}
      {currentPage !== 'billList' && (
        <>
          <Box
            sx={{
              flexGrow: 1,
              height: 0,
              overflowY: 'auto',
            }}
          >
            {currentPage === 'barcode' && (
              <>
                <Box
                  sx={{
                    marginTop: '2.9vw',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    flexGrow: '1',
                    overflowY: 'auto',
                    '& > *:not(:last-child)': {
                      marginBottom: '2.4vw',
                    },
                    '@media (orientation: landscape)': {
                      marginTop: '1.2vw',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      '& > *:not(:last-child)': {
                        marginBottom: '2.7vw',
                      },
                      '@media (orientation: landscape)': {
                        flexDirection: 'row',
                        '& > *:not(:last-child)': {
                          marginBottom: '1.1vw',
                        },
                      },
                    }}
                  >
                    {currentBarcode &&
                      Object.values(currentBarcode).map((barcode, i) => {
                        return <BarcodeItem key={i} {...{ barcode }} />;
                      })}
                  </Box>
                </Box>
              </>
            )}
            {currentPage === 'payInformation' && (
              <Box
                sx={{
                  width: '100%',
                  display: 'block',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: '3vw',
                  '@media (orientation: landscape)': {
                    marginTop: '1.5vw',
                  },
                }}
              >
                <MainText
                  sx={{
                    color: '#0063A0 !important',
                    marginTop: '1.3vw',
                    '@media (orientation: landscape)': {
                      marginTop: '0.45vw',
                    },
                  }}
                >
                  超過兩萬元，請透過轉帳或親臨管理室繳納
                </MainText>

                <MainText
                  sx={{
                    marginTop: '1.3vw',
                    '@media (orientation: landscape)': {
                      marginTop: '0.45vw',
                    },
                  }}
                >
                  {`匯款戶名：${communityData.payName}`}
                </MainText>
                <MainText
                  sx={{
                    marginTop: '1.3vw',
                    '@media (orientation: landscape)': {
                      marginTop: '0.45vw',
                    },
                  }}
                >
                  {`繳款帳號：${communityData.payId}`}
                </MainText>
              </Box>
            )}
            {bills.length > 0 && currentPage === 'detail' && (
              <>
                <BillDetail bill={currentBill} />
              </>
            )}
          </Box>
          <Box>
            <MainButton
              disableRipple
              sx={{
                marginTop: '2.8vw',
                '@media (orientation: landscape)': {
                  alignSelf: 'center',
                },
              }}
              onClick={handleReturnBillList}
            >
              關閉
            </MainButton>
          </Box>
        </>
      )}
      {html && (
        <form action={html.actionUrl} method="POST" id="text">
          {Object.keys(html).map((key) => (
            <input type="hidden" value={html[key]} name={key} key={key} />
          ))}
          <input
            type="submit"
            value="Submit"
            ref={btnRef}
            style={{ display: 'none' }}
          />
        </form>
      )}
    </Container>
  );
};

export default PayFrontDesk;
